'use strict';

var GridExportButtonDirective = function GridExportButtonDirective() {
  return {
    restrict: 'E',
    require: '^^rmGridToolbar',
    scope: true,
    template: require('../templates/grid-export-button.html'),
    controller: 'GridExportButtonController'
  };
};
GridExportButtonDirective.$inject = [];
module.exports = GridExportButtonDirective;